export default function disablePreviewClick(root) {
  root.root.find('iframe').on('load', (e) => {
    $(e.target).contents().find('a').on('click', (event) => {
      event.preventDefault();
    });
  });
}